import { useAtticLotListQuery } from "@dashboard/graphql";
import usePaginator, {
  createPaginationState,
  PaginatorContext,
} from "@dashboard/hooks/usePaginator";
import { mapEdgesToItems } from "@dashboard/utils/maps";

import AtticLotListPage from "../components/AtticLotListPage/AtticLotListPage";
import { type AtticLotListUrlQueryParams } from "../urls";

export const PAGINATE_BY = 50;

export const AtticLotListView = ({ params }: { params: AtticLotListUrlQueryParams }) => {
  const paginationState = createPaginationState(PAGINATE_BY, params);
  const { data, loading, error } = useAtticLotListQuery({
    displayLoader: true,
    variables: paginationState,
  });
  const paginationValues = usePaginator({
    pageInfo: data?.atticLots?.pageInfo,
    paginationState,
    queryString: params,
  });

  return (
    <PaginatorContext.Provider value={paginationValues}>
      <AtticLotListPage
        lots={loading && !data ? undefined : (mapEdgesToItems(data?.atticLots) ?? [])}
        loadFailed={!data && !loading && !!error}
      />
    </PaginatorContext.Provider>
  );
};

export default AtticLotListView;
